import { UserRole } from "~/types/user";

// Role name and color mapping
export const roleDisplayInfo: Record<
  UserRole,
  { name: string; color: string }
> = {
  superadmin: {
    name: "Administrador",
    color: "bg-gradient-to-r from-gray-700 to-gray-800",
  },
  admin: {
    name: "Admin",
    color: "bg-gradient-to-r from-gray-600 to-gray-800",
  },
  seller: {
    name: "Vendedor",
    color: "bg-gradient-to-r from-gray-600 to-gray-700",
  },
  logistica: {
    name: "Logística",
    color: "bg-gradient-to-r from-gray-700 to-gray-600",
  },
  cobranza: {
    name: "Cobranza",
    color: "bg-gradient-to-r from-gray-800 to-gray-700",
  },
  facturacion: {
    name: "Facturación",
    color: "bg-gradient-to-r from-blue-600 to-blue-700",
  },
  risk: {
    name: "Riesgo",
    color: "bg-gradient-to-r from-gray-700 to-gray-600",
  },
  transportista: {
    name: "Transportista",
    color: "bg-gradient-to-r from-green-600 to-green-700",
  },
  production: {
    name: "Producción",
    color: "bg-gradient-to-r from-orange-600 to-orange-700",
  },
  bodega: {
    name: "Bodega",
    color: "bg-gradient-to-r from-amber-600 to-amber-700",
  },
  "produccion-admin": {
    name: "Admin Producción",
    color: "bg-gradient-to-r from-orange-700 to-orange-800",
  },
  "asesor-fiscal": {
    name: "Asesor Fiscal",
    color: "bg-gradient-to-r from-slate-600 to-slate-700",
  },
};

export const getDisplayTitle = (pageTitle?: string): string => {
  return pageTitle || "Panel";
};
